module.exports = __webpack_public_path__ + "static/media/img-aboutUs01.e9428cae.e9428cae.jpg";